import * as colorToken from './color.token';
import * as typographyToken from './typography.token';
import * as spacingToken from '../../shared/common/spacing.token';

const typography = typographyToken.typography;
const color = colorToken.color;
const spacing = spacingToken.spacings;

export { color, typography , spacing };
